import React from "react";
import { GiftIcon } from "lucide-react";
import { CART_URL } from "../data/offer";
import { handleCheckoutClick } from "../utils/metaPixel";
export function TopBar() {
  return <div className="sticky top-0 z-50 bg-ink text-cream" data-id="element-232" data-mp="1y3kbj4sa3rsl">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-3 px-4 py-2.5 text-center text-xs font-semibold sm:text-sm" data-id="element-233" data-mp="1y42gqqwx5gcn">
        <GiftIcon className="hidden h-4 w-4 shrink-0 text-sun sm:block" aria-hidden="true" data-id="element-234" data-mp="2qs829fvsr9dj" />
        <p data-id="element-235" data-mp="2ltelnel7r295">
          <span className="font-extrabold" data-id="element-236" data-mp="2ltmwz21otzi8">Incluye:</span> ebook + 8 bonos exclusivos + kit para el celular
        </p>
        <a href={CART_URL} onClick={handleCheckoutClick} className="hidden shrink-0 rounded-full bg-sun px-4 py-1.5 font-bold text-ink transition-colors duration-150 ease-out hover:bg-sun-dark md:inline-block" data-id="element-237" data-mp="2h1wol1mb9ltg">
          Quiero empezar hoy
        </a>
      </div>
    </div>;
}